var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.videoId)?_c('img',{attrs:{"src":_vm.imageSrc,"alt":_vm.alt}}):_vm._e(),_vm._v(" "),(!_vm.videoId)?_c('img',{attrs:{"src":_vm.defaultPlaceholder,"alt":_vm.alt}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }